export default {
  findItemNum: function (array, id) {
    if (array == null) return null
    for (var i = 0; i < array.length; i++) {
      if (array[i].val.id === id) return i
    }
    return null
  },

  // array.sort(function (one, two) { return one.val.chainIndx > two.val.chainIndx }) почему-то не работает. работает на 95%, но некоторые элементы отсортировываются не как надо - УЖАС!!!
  // поэтому сделал сортировку сам bubbleSort
  /* sort: function (arr, compareFn) {
    var len = arr.length
    for (var i = len - 1; i >= 0; i--) {
      for (var j = 1; j <= i; j++) {
        // console.log(arr[j].val.chainIndx)
        if (compareFn(arr[j - 1], arr[j])) {
          var temp = arr[j - 1]
          arr[j - 1] = arr[j]
          arr[j] = temp
        }
      }
    }
    return arr
  } */
  sort: function (arr, compareFn) {
    var len = arr.length
    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len - i - 1; j++) {
        if (compareFn(arr[j], arr[j + 1]) === true) {
          var temp = arr[j]
          arr[j] = arr[j + 1]
          arr[j + 1] = temp
        }
      }
    }
    return arr
  }
}



// WEBPACK FOOTER //
// ./src/technical/arrayTools/arrayTools.js